(() => {
  if (customElements.get('tuzex-location-sizes')) return;
  class TuzexLocationSizes extends HTMLElement {
    connectedCallback() {
      this.records = new Map();
      this.onData = (event) => {
        this.readCache();
        this.readRecords(event.detail?.variantLocations);
        this.render();
      };
      this.onChange = () => this.render();
      document.addEventListener('inventoryInfo.appData', this.onData);
      document.addEventListener('inventoryInfo.appRendered', this.onData);
      this.addEventListener('change', this.onChange);
      queueMicrotask(() => {
        if (!this.isConnected) return;
        this.readCache();
        this.render();
      });
    }
    disconnectedCallback() {
      document.removeEventListener('inventoryInfo.appData', this.onData);
      document.removeEventListener('inventoryInfo.appRendered', this.onData);
      this.removeEventListener('change', this.onChange);
    }
    readCache() {
      const cache = window.inventoryInfo?.[this.dataset.productHandle];
      this.readRecords(cache?.variantLocations || cache?.data?.variantLocations);
    }
    readRecords(records) {
      if (!Array.isArray(records)) return;
      for (const record of records) {
        if (record?.variant && Array.isArray(record.inventoryLocations)) {
          this.records.set(String(record.variant), record.inventoryLocations);
        }
      }
    }
    stateFor(tile) {
      if (tile.dataset.purchasable !== 'true') return tile.dataset.variantId ? 'sold-out' : '';
      const locations = this.records.get(tile.dataset.variantId);
      if (!locations) return '';
      const stockedAt = (id) => locations.some((entry) =>
        String(entry.location?.id) === id && Number(entry.quantity) > 0
      );
      if (stockedAt(this.dataset.localLocation)) return 'local';
      if (stockedAt(this.dataset.externalLocation)) return 'external';
      return '';
    }
    render() {
      let selectedText = '';
      let selectedState = '';
      for (const tile of this.querySelectorAll('.tuzex-size-tile')) {
        const state = this.stateFor(tile);
        const local = state === 'local';
        const text = local ? this.dataset.localText : state === 'external' ? this.dataset.externalText : state === 'sold-out' ? this.dataset.soldOutText : '';
        tile.classList.toggle('tuzex-size-tile--stock', local);
        tile.dataset.locationState = state;
        tile.querySelector('.tuzex-size-tile__dot').hidden = !local;
        tile.querySelector('[data-location-description]').textContent = text;
        if (tile.previousElementSibling?.checked) {
          selectedText = text;
          selectedState = state;
        }
      }
      const delivery = this.querySelector('[data-selected-delivery]');
      delivery.hidden = !selectedText;
      delivery.dataset.locationState = selectedState;
      if (selectedState === 'local') {
        delivery.setAttribute('href', delivery.dataset.storeUrl);
      } else {
        delivery.removeAttribute('href');
      }
      if (delivery.textContent !== selectedText) delivery.textContent = selectedText;
    }
  }
  customElements.define('tuzex-location-sizes', TuzexLocationSizes);
})();
